import FalconComponentCard from "components/common/FalconComponentCard";
import React, { useCallback, useEffect, useState } from "react";
import { Button, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FiDownloadCloud } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { Form, useNavigate } from "react-router-dom";
import BranchListFilters from "./components/BranchListFilters";
import BranchListTable from "./components/BranchListTable";
import { GetAllBranchList } from "./config/branchApi";
import { handleBranchReset } from "./config/branchSlice";
import { toast } from "react-toastify";
import { handleDownloadXLSX } from "helpers/excel";
import { MdAdd } from "react-icons/md";
import paths from "routes/paths";
import moment from "moment";

const BranchList = () => {
  const dispatch = useDispatch();
  const { branchFilters, branchListData } = useSelector(
    (state) => state.branch
  );
  const { allPermissionType } = useSelector((state) => state.role);
  const branchSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Branch"
  );

  const { control, watch, handleSubmit, setValue, reset } = useForm({
    defaultValues: {
      name: "",
      cchi_no: "",
      nphies_id: "",
    },
  });
  const navigate = useNavigate();
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const requestBody = (customPage = page, customLimit = rowsPerPage) => ({
    branch_name: branchFilters?.name || "",
    branch_cchino: branchFilters?.cchi || "",
    nphies_id: branchFilters?.nphies_id || "",
    start_point: customPage,
    limit: customLimit,
  });

  const handlePageChange = useCallback((newPage) => {
    setPage(newPage);
  }, []);

  const handlePerRowsChange = useCallback((newPerPage) => {
    setRowsPerPage(newPerPage);
    setPage(0); // Reset to first page when changing page size
  }, []);

  const fetchBranchList = async (body = {}) => {
    try {
      const response = await dispatch(GetAllBranchList(body)).unwrap();
      setTotalRows(response?.total_rows || 0);
    } catch (error) {
      toast.error("Something Went Wrong");
    }
  };
  useEffect(() => {
    const body = requestBody(page, rowsPerPage);
    fetchBranchList(body);
  }, [page, rowsPerPage]);

  const handleCheckListFilter = () => {
    const newPage = 0;
    setPage(newPage); // Reset page
    const body = requestBody(newPage, rowsPerPage);
    fetchBranchList(body);
  };
  const handleReset = async () => {
    const body = {
      branch_name: "",
      branch_cchino: "",
      nphies_id: "",
      start_point: 0,
      limit: 10,
    };

    dispatch(handleBranchReset());
    reset();

    setPage(0);
    setRowsPerPage(10);
    setValue("name", null);
    reset();

    dispatch(handleBranchReset());

    const resetBody = requestBody(0, 10); // Fresh filters
    await fetchBranchList(body);
  };

  const handleDownloadExcel = async () => {
    const excelBody = requestBody(page, totalRows);
    await fetchBranchList(excelBody);
    const flattenedArray =
      branchListData &&
      branchListData.length > 0 &&
      branchListData.map((row, index) => [
        page * rowsPerPage + index + 1 || "",
        row?.branch_name || "",
        row?.branch_arabic_name || "",
        row?.branch_telephone || "",
        row?.branch_type || "",
        row?.branch_cchino || "",
        row?.branch_nphies_code || "",
        row?.branch_vatno || "",
        row?.branch_crno || "",
        row?.branch_building_no || "",
        row?.branch_additional_no || "",
        row?.branch_unit_no || "",
        row?.branch_street_name || "",
        row?.branch_district || "",
        row?.branch_district || "",
        row?.branch_zip_code || "",
        row?.branch_city || "",
        row?.branch_country || "",
      ]);

    handleDownloadXLSX(
      [
        [
          "No.",
          "Branch Name (Eng)",
          "Branch Name (Arabic)",
          "Phone No.",
          "Branch Type",
          "CHI No.",
          "Nphies ID",
          "VAT No",
          "CR No",
          "Building No",
          "Additional No",
          "Unit No",
          "Street Name",
          "District",
          "Zip Code",
          "City",
          "Country",
          "Bupa",
          "Tawuniya",
          "MedGulf",
          "Malath",
          "SAICO",
          "SABB",
          "Gulf Union",
          "Alrajhi Takaful",
          "Gulf Insurance Group",
          "Wataniyarn",
          "Medivisarn",
          "TCS",
          "Globemed",
          "Nextcare",
          "Al-Etihad",
          "MedNet",
        ],
        ...(flattenedArray || []), // ✅ Correctly spread the data
      ],
      `Branch_List_Export_${moment().format("DD-MM-YYYY_hh:mm:ss")}`
    );
  };

  return (
    <>
      {Number(branchSetting?.list) === 1 ? (
        <Form
          noValidate
          onSubmit={handleSubmit(handleCheckListFilter)}
          className="p-0"
        >
          <FalconComponentCard
            className="shadow-md"
            style={{ position: "relative" }}
          >
            <FalconComponentCard.Header
              className="d-flex  fixed-header justify-content-between align-items-center"
              sx={{
                position: "sticky !important",
                top: 68,
                zIndex: 1020,
                backgroundColor: "white",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <Col xs="auto m-0">
                <h5 className="text-primary mb-0 fs-10">Branch List</h5>
              </Col>
              <Col xs="auto" className="d-flex gap-2">
                <Button size="sm" variant="outline-danger" onClick={handleReset}>
                  Reset
                </Button>
                <Button
                  type="submit"
                  size="sm"
                  variant="success"
                // onClick={handleSubmit(handleCheckListFilter)}
                >
                  Filter
                </Button>
                {!!branchSetting?.add && (
                  <Button
                    size="sm"
                    variant="secondary"
                    onClick={() => navigate(paths.addBranch)}
                  >
                    <MdAdd />
                    New
                  </Button>
                )}
                {!!branchSetting?.export && (
                  <Button
                    size="sm"
                    variant="warning"
                    onClick={handleDownloadExcel}
                    className="d-flex align-items-center gap-1"
                  >
                    <FiDownloadCloud size={16} />
                    Excel
                  </Button>
                )}
              </Col>
            </FalconComponentCard.Header>
            <FalconComponentCard.Body
              style={{
                marginTop: "40px", // Adjust this value based on header height
                overflowY: "auto",
                maxHeight: "calc(100vh - 200px)", // Adjust based on your needs
              }}
            >
              <BranchListFilters
                watch={watch}
                control={control}
                setValue={setValue}
              />
              <BranchListTable
                data={branchListData}
                totalRows={totalRows}
                handlePageChange={handlePageChange}
                handlePerRowsChange={handlePerRowsChange}
                setting={branchSetting}
                page={page}
                rowsPerPage={rowsPerPage}
              />
            </FalconComponentCard.Body>
          </FalconComponentCard>
        </Form>
      ) : (
        <div className="py-6 text-center border rounded-3 mb-3">
          <h5 className="text-danger">Permission Denied</h5>
          <p className="text-muted fs-11">
            You do not have permission to view Branch list.
          </p>
        </div>
      )}
    </>
  );
};

export default BranchList;
